MyBrowser = require './MyBrowser'

class UADetector

  uaList = []

  constructor: ->
    @init()

  init: ->

    @$body = $('body')

    if MyBrowser.isOldIe()
      @$body.addClass('is-oldIe')
      uaList.push('oldIe')

    if MyBrowser.isSp()
      @$body.addClass('is-sp')
      uaList.push('sp')

    if MyBrowser.isTablet()
      @$body.addClass('is-tablet')
      uaList.push('tablet')

  getUA: ->
    return uaList

module.exports = UADetector



// WEBPACK FOOTER //
// ./src/scripts/modules/UADetector.coffee